import React from 'react';
import DOMPurify from 'dompurify';

type SanitizedHtmlProps = {
  html: string;
  className?: string;
  as?: React.ElementType;
};

const SanitizedHtml: React.FC<SanitizedHtmlProps> = ({
  html,
  className = '',
  as: Wrapper = 'div',
}) => {
  const sanitizedHtml = DOMPurify.sanitize(html, { ADD_ATTR: ['target'] });

  return <Wrapper className={className} dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />;
};

export default SanitizedHtml;
